/**
 * BFF Authentication Service — helper для Keycloak SSO flow (EyeHub).
 *
 * Портал EyeHub — SSO-only: локального email/password логина нет.
 *   - initiateLogin: browser-redirect на /api/v1/auth/keycloak/login/
 *   - isCallbackUrl + handleCallback: возврат из Keycloak после auth
 */

import { AUTH_FULL_PATHS } from "../api/constants";

class BFFAuthService {
  /**
   * Стартует Keycloak SSO flow: redirect на BFF login endpoint (инициирует OIDC).
   */
  initiateLogin() {
    window.location.href = AUTH_FULL_PATHS.KEYCLOAK_LOGIN;
    return { redirecting: true };
  }

  /**
   * Проверяет, обрабатывается ли callback от Keycloak.
   */
  isCallbackUrl() {
    return (
      window.location.pathname.includes(AUTH_FULL_PATHS.KEYCLOAK_CALLBACK) ||
      window.location.pathname.includes("/auth/callback")
    );
  }

  /**
   * Обрабатывает callback после успешной аутентификации в Keycloak.
   * Backend уже создал eyehub_session — здесь только проверяем сессию.
   */
  async handleCallback() {
    // Lazy import — избегаем циклической зависимости с authService.
    const { authService } = await import("./authService");
    return authService.checkAuthStatus();
  }
}

export const bffAuthService = new BFFAuthService();
export default bffAuthService;
